import React from 'react'
import Nav from './ui/Nav'

const Header = () => {
  return (
    <div className='Header'>
      <Nav />
    </div>
  )
}

export default Header